<template>
  <form class="columns" @submit.prevent="verifyFormValidaity" action="">
    <b-field
      label="Title"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('title') }"
      :message="errors.first('title')"
    >
      <b-autocomplete
        v-validate="'required'"
        name="title"
        open-on-focus
        rounded
        v-model="studentForm.title"
        :data="filteredTitles"
        icon="magnify"
        clearable
        @select="(option) => (studentForm.title = option)"
      >
        <template #empty>No results found</template>
      </b-autocomplete>
    </b-field>

    <b-field
      label="Current relationship status"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('married') }"
      :message="errors.first('married')"
    >
      <b-autocomplete
        v-validate="'required'"
        name="married"
        open-on-focus
        rounded
        v-model="studentForm.married"
        :data="filteredMaritalStatus"
        icon="magnify"
        clearable
        @select="(option) => (studentForm.married = option)"
      >
        <template #empty>No results found</template>
      </b-autocomplete>
    </b-field>

    <b-field
      label="First name"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('first_name') }"
      :message="errors.first('first_name')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.first_name"
        type="text"
        name="first_name"
      ></b-input>
    </b-field>

    <b-field
      label="Family name"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('last_name') }"
      :message="errors.first('last_name')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.last_name"
        type="text"
        name="last_name"
      ></b-input>
    </b-field>

    <b-field
      label="Date of birth"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('date_of_birth') }"
      :message="errors.first('date_of_birth')"
    >
      <b-datepicker
        v-validate="'required'"
        name="date_of_birth"
        v-model="studentForm.date_of_birth"
        locale="en-GB"
        :show-week-number="true"
        placeholder="Click to select..."
        icon="calendar-today"
        :icon-right="studentForm.date_of_birth ? 'close-circle' : ''"
        icon-right-clickable
        @icon-right-click="clearDate(null, 'date_of_birth')"
        trap-focus
      >
      </b-datepicker>
    </b-field>

    <b-field
      label="Nationality"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('nationality') }"
      :message="errors.first('nationality')"
    >
      <b-autocomplete
        v-validate="'required'"
        name="nationality"
        open-on-focus
        rounded
        v-model="studentForm.nationality"
        :data="filteredCountries('nationality', null)"
        icon="magnify"
        clearable
        @select="(option) => (studentForm.nationality = option)"
      >
        <template #empty>No results found</template>
      </b-autocomplete>
    </b-field>

    <b-field
      label="Town/village where you were born"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('town_birth') }"
      :message="errors.first('town_birth')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.town_birth"
        type="text"
        name="town_birth"
      ></b-input>
    </b-field>

    <b-field
      label="Email address"
      class="column is-one-third"
      :type="validEmail.type"
      :message="validEmail.message"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.email"
        type="text"
        name="email"
      ></b-input>
    </b-field>

    <b-field
      label="Phone number"
      class="column is-one-third"
      :type="validatePhoneNumber.type"
      :message="validatePhoneNumber.message"
    >
      <template #label>
        Phone number
        <b-tooltip type="is-dark" label="UK phone numbers only">
          <b-icon size="is-small" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-input
        v-validate="'required'"
        v-model="studentForm.phone_number"
        type="text"
        name="phone_number"
      ></b-input>
    </b-field>

    <b-field
      label="National Insurance Number"
      class="column is-one-third"
      :type="{ 'is-danger': errors.has('nat_ins_no') }"
      :message="errors.first('nat_ins_no')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.nat_ins_no"
        type="text"
        name="nat_ins_no"
      ></b-input>
    </b-field>

    <div class="columns column is-full">
      <b-field
        label="UK Address"
        class="column is-one-third"
        :type="{ 'is-danger': errors.has('house_number') }"
        :message="errors.first('house_number')"
      >
        <b-input
          v-validate="'required'"
          placeholder="House number"
          v-model="studentForm.house_number"
          type="text"
          name="house_number"
        ></b-input>
      </b-field>

      <b-field
        label="Street"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('street_address') }"
        :message="errors.first('street_address')"
      >
        <b-input
          v-validate="'required'"
          placeholder="Street"
          v-model="studentForm.street_address"
          type="text"
          name="street_address"
        ></b-input>
      </b-field>

      <b-field
        label="City"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('city') }"
        :message="errors.first('city')"
      >
        <b-input
          v-validate="'required'"
          placeholder="City"
          v-model="studentForm.city"
          type="text"
          name="city"
        ></b-input>
      </b-field>

      <b-field
        label="Country"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('country') }"
        :message="errors.first('country')"
      >
        <b-autocomplete
          v-validate="'required'"
          name="country"
          placeholder="Country"
          open-on-focus
          v-model="studentForm.country"
          :data="filteredCountries('country', null)"
          icon="magnify"
          clearable
          @select="(option) => (studentForm.country = option)"
        >
          <template #empty>No results found</template>
        </b-autocomplete>
      </b-field>

      <b-field
        label="Zip code"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('zip_code') }"
        :message="errors.first('zip_code')"
      >
        <b-input
          v-validate="'required'"
          placeholder="Postcode"
          v-model="studentForm.zip_code"
          type="text"
          name="zip_code"
        ></b-input>
      </b-field>
    </div>

    <b-field
      label="Disability"
      class="column is-full"
      :addons="false"
      :type="{ 'is-danger': errors.has('disability') }"
      :message="errors.first('disability')"
    >
      <b-radio
        v-model="studentForm.disability"
        name="disability"
        native-value="Yes"
        v-validate="'required'"
      >
        Yes
      </b-radio>
      <b-radio
        v-model="studentForm.disability"
        name="disability"
        native-value="No"
        v-validate="'required'"
      >
        No
      </b-radio>
    </b-field>

    <b-field
      v-if="studentForm.disability === 'Yes'"
      label="Describe"
      class="column is-full"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.disability_description"
        type="textarea"
        name="disability_description"
      ></b-input>
    </b-field>

    <b-field
      label="Previously applied for Student Finance?"
      :addons="false"
      class="column is-full"
      :type="{ 'is-danger': errors.has('studentFinanceApplied') }"
      :message="errors.first('studentFinanceApplied')"
    >
      <b-radio
        v-model="studentForm.studentFinanceApplied"
        name="studentFinanceApplied"
        native-value="Yes"
        v-validate="'required'"
      >
        Yes
      </b-radio>
      <b-radio
        v-model="studentForm.studentFinanceApplied"
        name="studentFinanceApplied"
        native-value="No"
        v-validate="'required'"
      >
        No
      </b-radio>
    </b-field>

    <b-field
      v-if="studentForm.studentFinanceApplied === 'Yes'"
      :type="{ 'is-danger': errors.has('studentFinanceAppliedDescription') }"
      :message="errors.first('studentFinanceAppliedDescription')"
      label="Please provide full course name, university or college name, date when the course started (month and year) and when the course finished (month and year) in the box above"
      class="column is-full"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.studentFinanceAppliedDescription"
        type="textarea"
        name="studentFinanceAppliedDescription"
      ></b-input>
    </b-field>

    <div class="columns column is-full">
      <b>Student residency status: {{ settledStatus }}</b>
    </div>

    <b-field
      v-if="settledStatus === 'Settled' || settledStatus === 'Pre-Settled'"
      label="If you been granted settled status, please provide your share code which you can get it from the link below for Student Finance to be able to verify your status in the UK"
      class="column is-full"
      :type="{ 'is-danger': errors.has('setttlementStatusDescription') }"
      :message="errors.first('setttlementStatusDescription')"
    >
      <a target="_blank" href="https://www.gov.uk/view-prove-immigration-status"
        >Link here</a
      >
      <b-input
        v-validate="'required'"
        class="columns column is-full"
        v-model="studentForm.setttlementStatusDescription"
        type="textarea"
        name="setttlementStatusDescription"
      ></b-input>
    </b-field>

    <b-field
      v-if="settledStatus === 'Pre-Settled'"
      label="If you been granted pre-settled status, please provide your share code and the expiry date of your pre-settle status for Student Finance to be able to verify your status in the UK. Please click the link below to get these details"
      class="column is-full"
      :type="{ 'is-danger': errors.has('setttlementStatusDescriptionPre') }"
      :message="errors.first('setttlementStatusDescriptionPre')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.setttlementStatusDescriptionPre"
        type="textarea"
        name="setttlementStatusDescriptionPre"
      ></b-input>
    </b-field>

    <b-field
      v-if="settledStatus === 'Pre-Settled' || settledStatus === 'Settled'"
      :addons="false"
      label="*Have you worked in the last 3 months before the start of the academic year?"
      class="column is-full"
      :type="{ 'is-danger': errors.has('workLast3Months') }"
      :message="errors.first('workLast3Months')"
    >
      <b-radio
        v-model="studentForm.workLast3Months"
        name="workLast3Months"
        native-value="Yes"
        v-validate="'required'"
      >
        Yes
      </b-radio>
      <b-radio
        v-model="studentForm.workLast3Months"
        name="workLast3Months"
        native-value="No"
        v-validate="'required'"
      >
        No
      </b-radio>
    </b-field>

    <b-message
      v-if="studentForm.workLast3Months === 'No'"
      class="column is-full"
      type="is-danger"
      has-icon
    >
      Your student does not meet the requirements for Student Finance.
    </b-message>

    <b-field
      v-if="studentForm.workLast3Months === 'Yes'"
      label="Provide datils of your employment (job title, company name). Let us know if you work employed or self-employed. "
      class="column is-full"
      :type="{ 'is-danger': errors.has('workLast3MonthsDescription') }"
      :message="errors.first('workLast3MonthsDescription')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.workLast3MonthsDescription"
        type="textarea"
        name="setttlementStatusDescription"
      ></b-input>
    </b-field>

    <p>
      Please provide your <b>full addresses</b> (house number, street name,
      postcode, country) <b>for the last 3 years</b> (since 01/01/2021) before
      the start of the academic year of your course. We need the day, month,
      year when you moved in and we need day, month, year when you moved out.
    </p>
    <b-button type="is-primary" @click="addAddress">Add new address</b-button>

    <b class="column is-full"
      >Full address total time spent:
      <b :class="fullAddressTimeSpent > 3 ? 'status-success' : 'status-danger'">
        {{ fullAddressTimeSpent }}
      </b></b
    >

    <div
      class="columns column is-full"
      v-for="(address, index) in studentForm.fullAdress"
      :key="index"
    >
      <b-field
        label="UK Address"
        class="column is-one-third"
        :type="{ 'is-danger': errors.has('house_number') }"
        :message="errors.first('house_number')"
      >
        <b-input
          v-validate="'required'"
          placeholder="House number"
          v-model="studentForm.fullAdress[index].house_number"
          type="text"
          name="house_number"
        ></b-input>
      </b-field>

      <b-field
        label="Street"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('street_address') }"
        :message="errors.first('street_address')"
      >
        <b-input
          v-validate="'required'"
          placeholder="Street"
          v-model="studentForm.fullAdress[index].street_address"
          type="text"
          name="street_address"
        ></b-input>
      </b-field>

      <b-field
        label="City"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('city') }"
        :message="errors.first('city')"
      >
        <b-input
          v-validate="'required'"
          placeholder="City"
          v-model="studentForm.fullAdress[index].city"
          type="text"
          name="city"
        ></b-input>
      </b-field>

      <b-field
        label="Country"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('country') }"
        :message="errors.first('country')"
      >
        <b-autocomplete
          placeholder="Country"
          name="country"
          open-on-focus
          v-model="studentForm.fullAdress[index].country"
          :data="filteredCountries('country', index)"
          icon="magnify"
          clearable
          @select="(option) => (studentForm.fullAdress[index].country = option)"
        >
          <template #empty>No results found</template>
        </b-autocomplete>
      </b-field>

      <b-field
        label="Zip code"
        class="column is-one-third hide-label"
        :type="{ 'is-danger': errors.has('zip_code') }"
        :message="errors.first('zip_code')"
      >
        <b-input
          v-validate="'required'"
          placeholder="Postcode"
          v-model="studentForm.fullAdress[index].zip_code"
          type="text"
          name="zip_code"
        ></b-input>
      </b-field>

      <b-button type="is-danger" @click="removeAddress(index)"
        >Remove address</b-button
      >

      <b-field
        label="Start date"
        class="column is-one-third"
        :type="{ 'is-danger': errors.has('start_date') }"
        :message="errors.first('start_date')"
      >
        <b-datepicker
          v-model="studentForm.fullAdress[index].start_date"
          name="start_date"
          locale="en-GB"
          :show-week-number="true"
          placeholder="Click to select..."
          icon="calendar-today"
          :icon-right="
            studentForm.fullAdress[index].start_date ? 'close-circle' : ''
          "
          icon-right-clickable
          @icon-right-click="clearDate(index, 'start_date')"
          trap-focus
        >
        </b-datepicker>
      </b-field>

      <b-field
        label="End date"
        class="column is-one-third"
        :type="{ 'is-danger': errors.has('end_date') }"
        :message="errors.first('end_date')"
      >
        <b-datepicker
          v-model="studentForm.fullAdress[index].end_date"
          name="end_date"
          locale="en-GB"
          :show-week-number="true"
          placeholder="Click to select..."
          icon="calendar-today"
          :icon-right="
            studentForm.fullAdress[index].end_date ? 'close-circle' : ''
          "
          icon-right-clickable
          @icon-right-click="clearDate(index, 'end_date')"
          trap-focus
        >
        </b-datepicker>
      </b-field>
    </div>

    <b-field
      label="University name and address "
      class="column is-full"
      :type="{ 'is-danger': errors.has('universityName') }"
      :message="errors.first('universityName')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.universityName"
        type="text"
        name="universityName"
      ></b-input>
    </b-field>

    <b-field
      label="Full course name "
      class="column is-full"
      :type="{ 'is-danger': errors.has('courseName') }"
      :message="errors.first('courseName')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.courseName"
        type="text"
        name="courseName"
      ></b-input>
    </b-field>

    <b-field
      label="Year of course (Foundation year/ First year/ Third year (Top-Up) and tuition fee for this course "
      class="column is-full"
      :type="{ 'is-danger': errors.has('year_course') }"
      :message="errors.first('year_course')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.year_course"
        type="text"
        name="year_course"
      ></b-input>
    </b-field>

    <b-field
      label="Provide TWO additional contacts from the UK (full name, relationship to you, phone number and address (house number, street name, post code) "
      class="column is-full"
      :type="{ 'is-danger': errors.has('uk_contacts') }"
      :message="errors.first('uk_contacts')"
    >
      <b-input
        v-validate="'required'"
        v-model="studentForm.uk_contacts"
        type="textarea"
        name="uk_contacts"
      ></b-input>
    </b-field>

    <b-field
      v-show="!isEslUniversity"
      label="Provide password and secret answer"
      class="column is-full"
      :type="{ 'is-danger': errors.has('provide_info') }"
      :message="errors.first('provide_info')"
    >
      <b-input
        :v-validate="isEslUniversity ? '' : 'required'"
        v-model="studentForm.provide_info"
        type="textarea"
        name="provide_info"
      ></b-input>
    </b-field>

    <b-field
      v-show="!isEslUniversity"
      label="Provide Customer Reference Number"
      class="column is-full"
      :type="{ 'is-danger': errors.has('provide_info_crn') }"
      :message="errors.first('provide_info_crn')"
    >
      <b-input
        :v-validate="isEslUniversity ? '' : 'required'"
        v-model="studentForm.provide_info_crn"
        type="textarea"
        name="provide_info_crn"
      ></b-input>
    </b-field>

    <!-- <b-field label="UK Bank Details (Sort Code and Account Number)" class="column is-full" :type="{ 'is-danger': errors.has('bank_details') }" :message="errors.first('bank_details')">
        <b-input v-validate="'required'" v-model="studentForm.bank_details" type="textarea" name="bank_details"></b-input>
    </b-field> -->

    <div class="columns column is-full">
      <b>Student settled status: {{ settledStatus }}</b>
    </div>

    <b-field
      label="*If you have children living with you under 16yo, provide NAME, DATE OF BIRTH "
      class="column is-full"
      :type="{ 'is-danger': errors.has('children_info') }"
      :message="errors.first('children_info')"
    >
      <b-input
        v-model="studentForm.children_info"
        type="textarea"
        name="children_info"
      ></b-input>
    </b-field>

    <div class="column is-full" v-if="isMarried || showParentDetails">
      <h3 class="column is-full">
        FINANCIAL DETAILS FOR THE PREVIOUS TAX YEAR FOR PARENTS AND PARTNERS
        <br />
        *If you are married or living with a partner, please complete the
        following section with your partner details.
      </h3>

      <div v-if="isMarried">
        <b-field
          label="Date of marriage"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('date_mariage') }"
          :message="errors.first('date_mariage')"
        >
          <b-datepicker
            required
            :v-validate="isMarried ? 'required' : ''"
            name="date_mariage"
            v-model="studentForm.date_mariage"
            locale="en-GB"
            :show-week-number="true"
            placeholder="Click to select..."
            icon="calendar-today"
            :icon-right="studentForm.date_mariage ? 'close-circle' : ''"
            icon-right-clickable
            @icon-right-click="clearDate(null, 'date_mariage')"
            trap-focus
          >
          </b-datepicker>
        </b-field>

        <b-field
          label="Partner full name "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_name') }"
          :message="errors.first('partner_name')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.partner_name"
            type="text"
            name="partner_name"
          ></b-input>
        </b-field>

        <b-field
          label="Partner date of birth"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_date_birth') }"
          :message="errors.first('partner_date_birth')"
        >
          <b-datepicker
            required
            :v-validate="isMarried ? 'required' : ''"
            name="partner_date_birth"
            v-model="studentForm.partner_date_birth"
            locale="en-GB"
            :show-week-number="true"
            placeholder="Click to select..."
            icon="calendar-today"
            :icon-right="studentForm.partner_date_birth ? 'close-circle' : ''"
            icon-right-clickable
            @icon-right-click="clearDate(null, 'partner_date_birth')"
            trap-focus
          >
          </b-datepicker>
        </b-field>

        <b-field
          label="Partner address "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_address') }"
          :message="errors.first('partner_address')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.partner_address"
            type="text"
            name="partner_address"
          ></b-input>
        </b-field>

        <b-field
          label="Partner phone number "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_phone_no') }"
          :message="errors.first('partner_phone_no')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.partner_phone_no"
            type="text"
            name="partner_phone_no"
          ></b-input>
        </b-field>

        <b-field
          label="Partner email address"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_email') }"
          :message="errors.first('partner_email')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.partner_email"
            type="text"
            name="partner_email"
          ></b-input>
        </b-field>

        <b-field
          label="Partner insurance number"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_ins_no') }"
          :message="errors.first('partner_ins_no')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.partner_ins_no"
            type="text"
            name="partner_ins_no"
          ></b-input>
        </b-field>

        <b-field
          label="Partner place (town or village) of birth "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_town_birth') }"
          :message="errors.first('partner_town_birth')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.partner_town_birth"
            type="text"
            name="partner_town_birth"
          ></b-input>
        </b-field>

        <b-field
          label="Is your Partner Employed, Self Employed or Employed?"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('partner_employ') }"
          :message="errors.first('partner_employ')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.partner_employ"
            type="text"
            name="partner_employ"
          ></b-input>
        </b-field>

        <b-field
          :label="`Did your Parent have any income from ${currentYear - 2} - ${
            currentYear - 1
          } tax year (P60 OR Tax calculation for the year in question)`"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parnter_income') }"
          :message="errors.first('parnter_income')"
        >
          <b-input
            :v-validate="isMarried ? 'required' : ''"
            v-model="studentForm.parnter_income"
            type="text"
            name="parnter_income"
          ></b-input>
        </b-field>
      </div>

      <div v-if="showParentDetails" class="column is-full">
        <b-field
          label="Parent full name "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_name_1') }"
          :message="errors.first('parent_name_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_name_1"
            type="text"
            name="parent_name_1"
          ></b-input>
        </b-field>

        <b-field
          label="Parent date of birth"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_date_birth_1') }"
          :message="errors.first('parent_date_birth_1')"
        >
          <b-datepicker
            required
            :v-validate="showParentDetails ? 'required' : ''"
            name="parent_date_birth_1"
            v-model="studentForm.parent_date_birth_1"
            locale="en-GB"
            :show-week-number="true"
            placeholder="Click to select..."
            icon="calendar-today"
            :icon-right="studentForm.parent_date_birth_1 ? 'close-circle' : ''"
            icon-right-clickable
            @icon-right-click="clearDate(null, 'parent_date_birth_1')"
            trap-focus
          >
          </b-datepicker>
        </b-field>

        <b-field
          label="Parent address "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_address_1') }"
          :message="errors.first('parent_address_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_address_1"
            type="text"
            name="parent_address_1"
          ></b-input>
        </b-field>

        <b-field
          label="Parent phone number "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_phone_1') }"
          :message="errors.first('parent_phone_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_phone_1"
            type="text"
            name="parent_phone_1"
          ></b-input>
        </b-field>

        <b-field
          label="Parent email address"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_email_1') }"
          :message="errors.first('parent_email_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_email_1"
            type="text"
            name="parent_email_1"
          ></b-input>
        </b-field>

        <b-field
          label="Parent insurance number"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_ins_no_1') }"
          :message="errors.first('parent_ins_no_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_ins_no_1"
            type="text"
            name="parent_ins_no_1"
          ></b-input>
        </b-field>

        <b-field
          label="Parent place (town or village) of birth "
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_town_birth_1') }"
          :message="errors.first('parent_town_birth_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_town_birth_1"
            type="text"
            name="parent_town_birth_1"
          ></b-input>
        </b-field>

        <b-field
          label="Is your Parent Employed, Self Employed or Employed?"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_employ_1') }"
          :message="errors.first('parent_employ_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_employ_1"
            type="text"
            name="parent_employ_1"
          ></b-input>
        </b-field>

        <b-field
          :label="`Did your Parent have any income from ${currentYear - 2} - ${
            currentYear - 1
          } tax year (P60 OR Tax calculation for the year in question)`"
          class="column is-one-third"
          :type="{ 'is-danger': errors.has('parent_income_1') }"
          :message="errors.first('parent_income_1')"
        >
          <b-input
            :v-validate="showParentDetails ? 'required' : ''"
            v-model="studentForm.parent_income_1"
            type="text"
            name="parent_income_1"
          ></b-input>
        </b-field>

        <b-field
          :addons="false"
          label="Second parent?"
          class="column is-full"
          :type="{ 'is-danger': errors.has('secondParent') }"
          :message="errors.first('secondParent')"
        >
          <b-radio
            v-model="studentForm.secondParent"
            name="secondParent"
            native-value="Yes"
            :v-validate="showParentDetails ? 'required' : ''"
          >
            Yes
          </b-radio>
          <b-radio
            v-model="studentForm.secondParent"
            name="secondParent"
            native-value="No"
            :v-validate="showParentDetails ? 'required' : ''"
          >
            No
          </b-radio>
        </b-field>
        <div v-if="studentForm.secondParent === 'Yes'">
          <b-field
            label="Parent full name "
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_name_2') }"
            :message="errors.first('parent_name_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_name_2"
              type="text"
              name="parent_name_2"
            ></b-input>
          </b-field>

          <b-field
            label="Parent date of birth"
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_date_birth_2') }"
            :message="errors.first('parent_date_birth_2')"
          >
            <b-datepicker
              required
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              name="parent_date_birth_2"
              v-model="studentForm.parent_date_birth_2"
              locale="en-GB"
              :show-week-number="true"
              placeholder="Click to select..."
              icon="calendar-today"
              :icon-right="
                studentForm.parent_date_birth_2 ? 'close-circle' : ''
              "
              icon-right-clickable
              @icon-right-click="clearDate(null, 'parent_date_birth_2')"
              trap-focus
            >
            </b-datepicker>
          </b-field>

          <b-field
            label="Parent address "
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_address_2') }"
            :message="errors.first('parent_address_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_address_2"
              type="text"
              name="parent_address_2"
            ></b-input>
          </b-field>

          <b-field
            label="Parent phone number "
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_phone_2') }"
            :message="errors.first('parent_phone_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_phone_2"
              type="text"
              name="parent_phone_2"
            ></b-input>
          </b-field>

          <b-field
            label="Parent email address"
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_email_2') }"
            :message="errors.first('parent_email_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_email_2"
              type="text"
              name="parent_email_2"
            ></b-input>
          </b-field>

          <b-field
            label="Parent insurance number"
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_ins_no_2') }"
            :message="errors.first('parent_ins_no_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_ins_no_2"
              type="text"
              name="parent_ins_no_2"
            ></b-input>
          </b-field>

          <b-field
            label="Parent place (town or village) of birth "
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_town_birth_2') }"
            :message="errors.first('parent_town_birth_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_town_birth_2"
              type="text"
              name="parent_town_birth_2"
            ></b-input>
          </b-field>

          <b-field
            label="Is your Parent Employed, Self Employed or Employed?"
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_employ_2') }"
            :message="errors.first('parent_employ_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_employ_2"
              type="text"
              name="parent_employ_2"
            ></b-input>
          </b-field>

          <b-field
            :label="`Did your Parent have any income from ${
              currentYear - 2
            } - ${
              currentYear - 1
            } tax year (P60 OR Tax calculation for the year in question)`"
            class="column is-one-third"
            :type="{ 'is-danger': errors.has('parent_income_2') }"
            :message="errors.first('parent_income_2')"
          >
            <b-input
              :v-validate="studentForm.secondParent === 'Yes' ? 'required' : ''"
              v-model="studentForm.parent_income_2"
              type="text"
              name="parent_income_2"
            ></b-input>
          </b-field>
        </div>
      </div>
    </div>

    <div class="sfe-message">
      <b-icon
        v-if="isManagement || studentFormComments.length"
        class="cursor-pointer"
        @click.native.prevent="showMessageBubble = !showMessageBubble"
        icon="message-alert"
        size="is-large"
        type="is-danger"
      ></b-icon>
      <button type="submit" class="ml-5 mt-2 button is-primary">
        <span>Submit Form</span>
      </button>
      <b-button type="is-secondary" class="ml-5 mt-2" @click="saveAsDraft"
        >Save as Draft</b-button
      >
      <div class="sfe-message__bubble" v-if="showMessageBubble">
        <div
          class="pl-5"
          v-for="(message, index) in studentFormComments"
          :key="index"
        >
          <b>{{ message }}</b>
        </div>

        <div class="columnns is-full" v-if="isManagement">
          <b-field
            label="Leave a comment for the SFE Form"
            class="column is-full"
          >
            <b-input
              v-validate="'required'"
              v-model="studentFormComment"
              type="textarea"
              name="studentFormComment"
            ></b-input>
          </b-field>
          <b-button
            size="is-med"
            class="message-send"
            rounded
            @click="addCustomMessage()"
            icon-left="send-circle-outline"
          >
            Send
          </b-button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import UtilService from '../../services/util';
import StudentService from '../../services/student.service';
import { userTitles, countryList, maritalStatus } from '../../models/static';
import moment from 'moment';

export default {
  name: 'sfe-form',
  props: ['id', 'templateOptions', 'fullCourse', 'appRow'],
  data() {
    return {
      studentForm: {
        title: '',
        first_name: '',
        last_name: '',
        date_of_birth: null,
        nationality: '',
        town_birth: '',
        phone_number: '+44',
        email: '',
        nat_ins_no: '',
        married: '',
        country: '',
        zip_code: '',
        house_number: '',
        street_address: '',
        city: '',
        disability: null,
        disability_description: '',
        studentFinanceApplied: false,
        studentFinanceAppliedDescription: '',
        setttlement_status: '',
        setttlementStatusDescription: '',
        setttlementStatusDescriptionPre: '',
        workLast3Months: false,
        workLast3MonthsDescription: '',
        fullAdress: [],
        universityName: '',
        courseName: '',
        course_length: '',
        year_course: '',
        uk_contacts: '',
        date_mariage: null,
        partner_name: '',
        partner_date_birth: null,
        partner_address: '',
        partner_phone_no: '',
        partner_email: '',
        partner_ins_no: '',
        partner_town_birth: '',
        partner_employ: '',
        parnter_income: '',
        children_info: '',
        parent_name_1: '',
        parent_date_birth_1: null,
        parent_address_1: '',
        parent_phone_1: '',
        parent_email_1: '',
        parent_ins_no_1: '',
        parent_town_birth_1: '',
        parent_employ_1: '',
        secondParent: '',
        parent_name_2: '',
        parent_date_birth_2: null,
        parent_address_2: '',
        parent_phone_2: '',
        parent_email_2: '',
        parent_ins_no_2: '',
        parent_town_birth_2: '',
        parent_employ_2: '',
        provide_info_crn: '',
        provide_info: '',
      },
      showMessageBubble: false,
      studentFormComment: '',
      studentFormComments: [],
      studentFormProp: {},
      isEslUniversity: false,
    };
  },
  created() {
    if (!this.id) {
      this.$router.push('/payment');
      return;
    }

    this.fillForm();
  },
  watch: {},
  computed: {
    isUnderAge() {
      return moment().diff(this.studentForm.date_of_birth, 'years') < 25;
    },
    isMarried() {
      return (
        this.studentForm.married === 'Married' ||
        this.studentForm.married === 'Living with a partner'
      );
    },
    showParentDetails() {
      return (
        this.isUnderAge &&
        !this.isMarried &&
        this.studentForm.children_info.length === 0
      );
    },
    isManagement() {
      return UtilService.isManagement();
    },
    isAdmin() {
      return UtilService.isAdmin();
    },
    currentYear() {
      return UtilService.currentYear();
    },
    fullAddressTimeSpent() {
      return this.studentForm.fullAdress.length === 0
        ? 0
        : this.studentForm.fullAdress
            .map((address) =>
              this.dateDiffInYears(address.start_date, address.end_date)
            )
            .reduce((a, b) => a + b, 0);
    },

    settledStatus() {
      return this.templateOptions && this.templateOptions.applicationInformation
        ? this.templateOptions.applicationInformation.setttlement_status
        : null;
    },

    filteredTitles() {
      return this.studentForm.title
        ? userTitles.filter((option) => {
            return (
              option
                .toString()
                .toLowerCase()
                .indexOf(this.studentForm.title.toLowerCase()) >= 0
            );
          })
        : userTitles;
    },

    filteredMaritalStatus() {
      return this.studentForm.married
        ? maritalStatus.filter((option) => {
            return (
              option
                .toString()
                .toLowerCase()
                .indexOf(this.studentForm.married.toLowerCase()) >= 0
            );
          })
        : maritalStatus;
    },

    validatePhoneNumber() {
      const phoneNo = this.studentForm.phone_number;
      if (phoneNo && phoneNo.toString().replace(/\D/g, '').length >= 10) {
        return {
          isValid: true,
          type: 'is-success',
          message: '',
        };
      } else {
        return {
          isValid: false,
          type: 'is-danger',
          message: 'Phone number is not a valid UK number',
        };
      }
    },

    validEmail() {
      const validEmail = this.validateEmail(this.studentForm.email);

      if (!validEmail) {
        return {
          isValid: false,
          type: 'is-danger',
          message: 'This email is invalid',
        };
      } else {
        return {
          isValid: true,
          type: 'is-success',
          message: '',
        };
      }
    },
  },
  methods: {
    verifyFormValidaity() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          for (var i = 0; i < this.errors.items.length; i++) {
            this.errors.items[i].msg = this.errors.items[i].msg.replaceAll(
              '_',
              ' '
            );
          }
          this.$buefy.toast.open({
            duration: 3000,
            message: 'Fields with no values were found!',
            position: 'is-bottom',
            type: 'is-danger',
          });
          return;
        }

        const warningMessage =
          this.fullAddressTimeSpent < 3
            ? 'Less than 3 years spent in the UK'
            : (this.settledStatus === 'Pre-Settled' ||
                this.settledStatus === 'Settled') &&
              this.studentForm.workLast3Months === 'No'
            ? 'Student has not worked in the last 3 months'
            : null;

        if (warningMessage) {
          this.$buefy.toast.open({
            duration: 3000,
            message: warningMessage,
            position: 'is-bottom',
            type: 'is-danger',
          });

          return;
        }

        this.saveForm('Awaiting review', `SFE Form submitted`);
      });
    },

    async fillForm() {
      await StudentService.getSFE(this.id).then((response) => {
        this.studentFormProp =
          response.data.student && response.data.student.student_finance
            ? response.data.student.student_finance.studentForm
            : null;

        if (!this.studentFormProp) {
          this.studentForm = {
            ...this.studentForm,
            universityName:
              this.fullCourse.university.title +
              ' - ' +
              this.fullCourse.university.address,
            courseName: this.fullCourse.title,
            title: this.templateOptions.personalInformation.title,
            first_name: this.templateOptions.personalInformation.first_name,
            last_name: this.templateOptions.personalInformation.last_name,
            date_of_birth: this.convertDate(
              this.templateOptions.personalInformation.date_of_birth
            ),
            nationality: this.templateOptions.personalInformation.nationality,
            email: this.templateOptions.personalInformation.email,
            phone_number: this.templateOptions.personalInformation.phone_number,
            year_course: this.templateOptions.personalInformation.year_course,
            country: this.templateOptions.personalInformation.country,
            zip_code: this.templateOptions.personalInformation.zip_code,
            house_number: this.templateOptions.personalInformation.house_number,
            street_address:
              this.templateOptions.personalInformation.street_address,
            city: this.templateOptions.personalInformation.city,
            studentFinanceApplied: this.templateOptions.applicationInformation
              ? this.templateOptions.applicationInformation
                  .studentFinanceApplied
              : false,
          };
        } else {
          let studentForm = this.studentFormProp
            ? JSON.parse(this.studentFormProp)
            : null;

          if (studentForm) {
            this.isEslUniversity =
              response.data.course.university.title.startsWith('ESL');
            if (this.isEslUniversity) {
              delete studentForm.provide_info_crn;
              delete studentForm.provide_info;
              delete this.studentForm.provide_info_crn;
              delete this.studentForm.provide_info;
            }
            const fullAdress = studentForm.fullAdress
              ? studentForm.fullAdress.map((address) => {
                  return {
                    ...address,
                    start_date: this.convertDate(address.start_date),
                    end_date: this.convertDate(address.end_date),
                  };
                })
              : [];

            this.studentForm = {
              ...studentForm,
              date_of_birth: this.convertDate(studentForm.date_of_birth),
              date_mariage: this.convertDate(studentForm.date_mariage),
              partner_date_birth: this.convertDate(
                studentForm.partner_date_birth
              ),
              parent_date_birth_1: this.convertDate(
                studentForm.parent_date_birth_1
              ),
              parent_date_birth_2: this.convertDate(
                studentForm.parent_date_birth_2
              ),
              fullAdress,
            };
          }

          this.studentFormComments = this.studentFormProp.studentFormComments
            ? JSON.parse(this.studentFormProp.studentFormComments)
            : [];
        }
      });
    },

    saveAsDraft() {
      this.saveForm('Draft', `SFE Form saved as draft`);
    },

    saveForm(studentFormStatus, message) {
      const studentForm = JSON.stringify(this.studentForm);
      const currentTime = moment().format('DD-MM-YYYY, h:mm:ss a');
      const currentUser = UtilService.currentUser().username;
      const sfeLastUpdated = currentTime + ' - ' + currentUser;
      StudentService.updateSFE({
        studentId: this.id,
        studentForm,
        studentFormStatus,
        sfeLastUpdated,
      }).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message,
          position: 'is-bottom',
          type: 'is-success',
        });

        const value = {
          ...this.studentFormProp,
          studentFormStatus,
          studentForm,
        };

        this.$eventHub.$emit('socket__event', {
          messageType: 'socket__edit-application',
          messageValue: {
            path: ['studentForm'],
            studentValue: this.id,
            value,
            setData: true,
          },
        });

        this.$store.dispatch('application/toggleEditCell', {
          studentValue: this.appRow,
          path: ['studentForm'],
          value,
          setData: false,
        });
      });
    },

    addCustomMessage() {
      this.studentFormComments.push(this.studentFormComment);

      StudentService.updateSFE({
        studentId: this.id,
        studentFormComments: JSON.stringify(this.studentFormComments),
      }).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: `SFE comment submitted`,
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },

    addAddress() {
      this.studentForm.fullAdress.push({
        country: '',
        zip_code: '',
        house_number: '',
        street_address: '',
        city: '',
        start_date: this.convertDate('2021-01-01'),
        end_date: this.convertDate('2021-01-01'),
      });
    },

    removeAddress(index) {
      this.studentForm.fullAdress.splice(index, 1);
    },

    dateDiffInYears(a, b) {
      if (!a || !b) {
        return 0;
      }
      const _MS_PER_DAY = 365 * 1000 * 60 * 60 * 24;
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return (utc2 - utc1) / _MS_PER_DAY;
    },

    filteredCountries(field, index) {
      if (index !== null && !this.studentForm.fullAdress[index].country) {
        return countryList;
      } else if (!field || !this.studentForm[field]) {
        return countryList;
      }

      const toCheck =
        index !== null
          ? this.studentForm.fullAdress[index].country
          : this.studentForm[field].toLowerCase();

      return countryList.filter((option) => {
        return option.toString().toLowerCase().indexOf(toCheck) >= 0;
      });
    },

    clearDate(index, type) {
      if (index !== null) {
        this.studentForm.fullAdress[index][type] = null;
      } else {
        this.studentForm[type] = null;
      }
    },

    convertDate(deadline) {
      if (deadline == null) {
        return deadline;
      } else if (new Date(deadline).toString() !== 'Invalid Date') {
        return moment(deadline).toDate();
      } else if (typeof deadline === 'string' || deadline instanceof String) {
        return moment(deadline, 'DD-MM-YYYY').toDate();
      }

      return null;
    },

    validateEmail(email) {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(email);
    },
  },
};
</script>

<style>
.sfe-message {
  position: fixed;
  bottom: 0;
  right: 0;
  background: white;
  left: 0;
  z-index: 100;
}
</style>
